import Moment from 'moment';
import { ChartDataPoint } from '../../../graphs/axisUtils';

type ResponseDataPoint = { timestamp: string | null, value: number | null };

export const getDayIndex = (date: Date): number => {
  const dayIndex: number = date.getDay() - 1;
  return dayIndex < 0 ? 6 : dayIndex;
};

export const dataGroupedByDay = (data: ChartDataPoint[], dayIndex: number | null) => data
  ?.reduce((total: number[][], point: ChartDataPoint) => {
    const date: Date = new Date(point.date);
    if (!(Number.isFinite(point.value) && (dayIndex === null || getDayIndex(date) === dayIndex))) {
      return total;
    }
    const index: number = date.getHours();
    if (!total[index]) return total;
    total[index].push(point.value);
    return total;
  }, [...new Array(24)].map(() => [])).map((item: number[], index: number) => ({
    index,
    date: `${(index < 12 ? index : index - 12) || 12}${index < 12 ? 'am' : 'pm'}`,
    value: item.reduce((total: number, value: number) => total + value, 0) / (item.length || 1),
  }));

export const occupiedHours = (data: ChartDataPoint[], singleDay: boolean = false) => {
  if (!data) return null;
  const dataObj: Record<string, number> = data
    .reduce((total: Record<string, number>, point: ChartDataPoint) => {
      if (!point.value) return total;
      const date: Date = new Date(point.date);
      const key: string = Moment(date).utc().startOf(singleDay ? 'hour' : 'day').toISOString();
      if (!(total[key] >= 0)) total[key] = 0;
      total[key] += 1;
      return total;
    }, {});
  return Object.keys(dataObj)
    .map((date: string, index: number) => ({ index, date, value: dataObj[date] }));
};

export const filterMetricData = (data: ResponseDataPoint[]) => data
  ?.filter((item: ResponseDataPoint) => !!item.timestamp)
  ?.map((item: ResponseDataPoint, index: number) => ({
    index,
    date: item.timestamp,
    value: item.value,
  }));
